import { useEffect } from "react";
import useGlobalState from "../../../hooks/useGlobalState";
import store from "../../../store";
import msalAuthenticationService from "../../../services/authentication/msalAuthenticationService";
const LoginPage = () => {
    const { isAppLoading, hasError } = useGlobalState(store.auth);
    useEffect(() => {
        if (isAppLoading || hasError)
            return;
        msalAuthenticationService.signIn();
    }, [isAppLoading, hasError]);
    return null;
};
export default LoginPage;
